import styled from 'styled-components';

export const SearchContainer = styled.div`
  margin: 30px 0;
`;

export const SearchDetail = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
  padding-top: 38px;
  @media only screen and (max-width: 720px) {
    font-size: 14px;
    padding-top: ${props => props.theme.spacing.paddings.webBase};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  ${({ Search }) =>
    Search &&
    `
	width: 100%;
	.ant-input-affix-wrapper {
		width: 100%;
	}
	`}
  ${({ Sort }) =>
    Sort &&
    `
	padding-top: 20px;
	align-items: center;
	& > p {
		margin: auto;
		padding-right: 10px;
		line-height: 20px;
		font-size: 14px;
		color: #505050;
    font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;   
	}
`}
  ${({ Filter }) =>
    Filter &&
    `
	padding-top: 20px;
	justify-content: space-between;
`}
${({ AlignCenter }) =>
  AlignCenter &&
  `
	align-items: center;
`}
`;

export const FilterWrapper = styled.img`
  display: block;
  padding: 12px;
  border: 1px solid #d4d4d4;
`;

export const FilterSorter = styled.div`
  width: 55%;
`;

export const SearchHead = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.primary};
  margin-right: 10px;
  vertical-align: middle;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const Sort = styled.div`
  display: inline-block;
`;

export const View = styled.div`
  display: inline-block;
`;

export const Sorter = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Filter = styled.div`
  margin-top: 30px;
`;
